export const SET_GOAL = "SET_GOAL";
export const SET_SAVINGS_PLAN_ID = "SET_SAVINGS_PLAN_ID";
export const GET_QUESTIONS_BY_GOAL_TYPE_SUCCESS =
  "GET_QUESTIONS_BY_GOAL_TYPE_SUCCESS";
export const GET_QUESTIONS_BY_GOAL_TYPE_FAIL =
  "GET_QUESTIONS_BY_GOAL_TYPE_FAIL";
export const SET_LOADING = "SET_LOADING";
export const GET_SAVINGS_PLAN_SUCCESS = "GET_SAVINGS_PLAN_SUCCESS";
export const GET_SAVINGS_PLAN_FAIL = "GET_SAVINGS_PLAN_FAIL";
export const SET_PROGRAM_DURATION = "SET_PROGRAM_DURATION";
export const SET_PROGRAM_COST = "SET_PROGRAM_COST";
export const GET_USER_ACCOUNT_DETAILS = "GET_USER_ACCOUNT_DETAILS";
export const GET_USER_ACCOUNT_DETAILS_FAIL = "GET_USER_ACCOUNT_DETAILS_FAIL";
export const SET_USER_ACCOUNT_DETAILS = "SET_USER_ACCOUNT_DETAILS";
export const RESET_USER_ACCOUNT_DETAILS = "RESET_USER_ACCOUNT_DETAILS";
export const SET_USER_ACCOUNT_DETAILS_FAIL = "SET_USER_ACCOUNT_DETAILS_FAIL";
export const GET_USER_GOALS = "GET_USER_GOALS";
export const GET_USER_GOAL_FAIL = "GET_USER_GOAL_FAIL";
export const SET_USER_FINANCIAL_ADVISOR_MAIL =
  "SET_USER_FINANCIAL_ADVISOR_MAIL";
export const DELETE_USER_GOAL = "DELETE_USER_GOAL";
export const DELETE_USER_GOAL_FAIL = "DELETE_USER_GOAL_FAIL";
export const SET_GOAL_TO_LAUNCH = "SET_GOAL_TO_LAUNCH";
export const SET_GOAL_TO_LAUNCH_FAIL = "SET_GOAL_TO_LAUNCH_FAIL";
export const RESET_GOAL_TO_LAUNCH = "RESET_GOAL_TO_LAUNCH";
export const SET_ID = "SET_ID";
export const SET_USER_ACCEPTED_TERMS = "SET_USER_ACCEPTED_TERMS";
export const SET_USER_ACCEPTED_TERMS_FAIL = "SET_USER_ACCEPTED_TERMS_FAIL";
export const SUBMIT_USER_ANSWER_SUCCESS = "SUBMIT_USER_ANSWER_SUCCESS";
export const SUBMIT_USER_ANSWER_FAIL = "SUBMIT_USER_ANSWER_FAIL";
export const SET_SAVINGS_PLAN_SUCCESS = "SET_SAVINGS_PLAN_SUCCESS";
export const RESET_SAVINGS_PLAN = "RESET_SAVINGS_PLAN";
export const ADD_OTHER_CUSTODIANS_FAIL = "ADD_OTHER_CUSTODIANS_FAIL";
export const ADD_CUSTODIAN_TYPE_FAIL = "ADD_CUSTODIAN_TYPE_FAIL";
export const ADD_OTHER_CUSTODIANS_SUCCESS = "ADD_OTHER_CUSTODIANS_SUCCESS";
export const RESET_CUSTODIANS_SUCCESS = "RESET_CUSTODIANS_SUCCESS";
export const SET_GOAL_TO_LAUNCH_PAYLOAD = "SET_GOAL_TO_LAUNCH_PAYLOAD";
export const ADD_CUSTODIAN_TYPE_SUCCESS = "ADD_CUSTODIAN_TYPE_SUCCESS";
export const GET_NEW_DASHBOARD_INFORMATION_SUCCESS =
  "GET_NEW_DASHBOARD_INFORMATION_SUCCESS";
export const GET_NEW_DASHBOARD_INFORMATION_FAIL =
  "GET_NEW_DASHBOARD_INFORMATION_FAIL";
export const GET_INDIVIDUAL_FORM_FAIL = "GET_INDIVIDUAL_FORM_FAIL";
export const GET_INDIVIDUAL_FORM_SUCCESS = "GET_INDIVIDUAL_FORM_SUCCESS";
export const POST_INDIVIDUAL_FORM = "POST_INDIVIDUAL_FORM";
export const POST_INDIVIDUAL_FORM_FAIL = "POST_INDIVIDUAL_FORM_FAIL";
export const POST_RIA_FORM = "POST_RIA_FORM";
export const POST_RIA_FORM_FAIL = "POST_RIA_FORM_FAIL";
export const POST_JOINT_FORM = "POST_JOINT_FORM";
export const POST_JOINT_FORM_FAIL = "POST_JOINT_FORM_FAIL";
export const GET_CONTACT_INFORMATION = "GET_CONTACT_INFORMATION";
export const GET_CONTACT_INFORMATION_FAIL = "GET_CONTACT_INFORMATION_FAIL";
export const POST_VERIFICATION_FORM = "POST_VERIFICATION_FORM";
export const POST_VERIFICATION_FORM_FAIL = "POST_VERIFICATION_FORM_FAIL";
export const ESTABLISH_SSO_CONNECTION_SUCCESS =
  "ESTABLISH_SSO_CONNECTION_SUCCESS";
export const ESTABLISH_SSO_CONNECTION_FAIL = "ESTABLISH_SSO_CONNECTION_FAIL";
export const RESET_ESTABLISH_SSO_CONNECTION_SUCCESS =
  "RESET_ESTABLISH_SSO_CONNECTION_SUCCESS";
export const RESET_ALL_FORM_DATA = "RESET_ALL_FORM_DATA";
export const RESET_VERIFICATION_FORM = "RESET_VERIFICATION_FORM";
export const GET_TRANSFER_GOALS_SUCCESS = "GET_TRANSFER_GOALS_SUCCESS";
export const GET_TRANSFER_GOALS_FAIL = "GET_TRANSFER_GOALS_FAIL";
export const SET_TRANSFER_GOALS_SUCCESS = "SET_TRANSFER_GOALS_SUCCESS";
export const SET_TRANSFER_GOALS_FAIL = "SET_TRANSFER_GOALS_FAIL";
export const RESET_TRANSFER_GOALS_SUCCESS = "RESET_TRANSFER_GOALS_SUCCESS";
export const GET_ADVISOR_NAME = "GET_ADVISOR_NAME";
export const GET_ADVISOR_NAME_FAIL = "GET_ADVISOR_NAME_FAIL";
export const RESET_ADVISOR_NAME = "RESET_ADVISOR_NAME";
export const RESET_NEW_DASHBOARD_INFORMATION =
  "RESET_NEW_DASHBOARD_INFORMATION";
export const SET_GOAL_RENAME = "SET_GOAL_RENAME";
export const SIGN_ADVISORY_SUCCESS = "SIGN_ADVISORY_SUCCESS";
export const SIGN_ADVISORY_FAIL = "SIGN_ADVISORY_FAIL";
export const GET_ACCOUNT_OVERVIEW_SUCCESS = "GET_ACCOUNT_OVERVIEW_SUCCESS";
export const GET_ACCOUNT_OVERVIEW_FAIL = "GET_ACCOUNT_OVERVIEW_FAIL";
export const RESET_DASHBOARD_DATA = "RESET_DASHBOARD_DATA";
export const SET_LOGIN_SUCCESS_RESPONSE = "SET_LOGIN_SUCCESS_RESPONSE";
export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const GET_DOCUMENTS_FAIL = "GET_DOCUMENTS_FAIL";
export const RESET_QA = "RESET_QA";
export const SET_FIRST_LOGIN = "SET_FIRST_LOGIN";
export const RESET_INDIVIDUAL_INFORMATION = "RESET_INDIVIDUAL_INFORMATION";
export const RESET_JOINT_INFORMATION = "RESET_JOINT_INFORMATION";
export const RESET_RIA_INFORMATION = "RESET_RIA_INFORMATION";
export const GET_IBKR_DEPOSIT_FUNDS_URL_SUCCESS =
  "GET_IBKR_DEPOSIT_FUNDS_URL_SUCCESS";
export const GET_IBKR_DEPOSIT_FUNDS_URL_FAIL =
  "GET_IBKR_DEPOSIT_FUNDS_URL_FAIL";
export const GET_LIST_OF_ADVISORS_SUCCESS = "GET_LIST_OF_ADVISORS_SUCCESS";
export const GET_LIST_OF_ADVISORS_FAIL = "GET_LIST_OF_ADVISORS_FAIL";
export const GET_ADVISOR_CLIENT_DETAILS_SUCCESS =
  "GET_ADVISOR_CLIENT_DETAILS_SUCCESS";
export const GET_ADVISOR_CLIENT_DETAILS_FAIL =
  "GET_ADVISOR_CLIENT_DETAILS_FAIL";
export const RESET_CLIENT_SUMMARRY_DATA = "RESET_CLIENT_SUMMARRY_DATA";
export const GET_ADVISOR_DETAILS_SUCCESS = "GET_ADVISOR_DETAILS_SUCCESS";
export const GET_ADVISOR_DETAILS_FAIL = "GET_ADVISOR_DETAILS_FAIL";
export const RESET_ADVISOR_DETAILS_DATA = "RESET_ADVISOR_DETAILS_DATA";
export const GET_INDIVIDUAL_ACCOUNT_NOTES_SUCCESS =
  "GET_INDIVIDUAL_ACCOUNT_NOTES_SUCCESS";
export const GET_INDIVIDUAL_ACCOUNT_NOTES_FAIL =
  "GET_INDIVIDUAL_ACCOUNT_NOTES_FAIL";
export const SET_ADVISOR_NOTE_SUCCESS = "SET_ADVISOR_NOTE_SUCCESS";
export const SET_ADVISOR_NOTE_FAIL = "SET_ADVISOR_NOTE_FAIL";
export const RESET_INDIVIDUAL_ACCOUNT_NOTES = "RESET_INDIVIDUAL_ACCOUNT_NOTES";
export const GET_INDIVIDUAL_ACCOUNT_DETAILS_SUCCESS =
  "GET_INDIVIDUAL_ACCOUNT_DETAILS_SUCCESS";
export const GET_INDIVIDUAL_ACCOUNT_DETAILS_FAIL =
  "GET_INDIVIDUAL_ACCOUNT_DETAILS_FAIL";
export const GET_INVITE_CLIENT_ADVISOR_LIST_SUCCESS =
  "GET_INVITE_CLIENT_ADVISOR_LIST_SUCCESS";
export const GET_INVITE_CLIENT_ADVISOR_LIST_FAIL =
  "GET_INVITE_CLIENT_ADVISOR_LIST_FAIL";
export const INVITE_CLIENT_SUCCESS = "INVITE_CLIENT_SUCCESS";
export const INVITE_CLIENT_FAIL = "INVITE_CLIENT_FAIL";
export const GET_LIST_OF_INCOMING_ADVISORS_SUCCESS =
  "GET_LIST_OF_INCOMING_ADVISORS_SUCCESS";
export const GET_LIST_OF_INCOMING_ADVISORS_FAIL =
  "GET_LIST_OF_INCOMING_ADVISORS_FAIL";
export const SET_FILTER_SAVE_CLICK = "SET_FILTER_SAVE_CLICK";
export const SET_FILTER_CLEAR_CLICK = "SET_FILTER_CLEAR_CLICK";
export const RESET_FILTER_CLICK = "RESET_FILTER_CLICK";
export const APPLY_FILTER_CLIENT_LIST_TABLE = "APPLY_FILTER_CLIENT_LIST_TABLE";
export const GET_INCOMING_CLIENT_DETAILS_SUCCESS =
  "GET_INCOMING_CLIENT_DETAILS_SUCCESS";
export const GET_CUSTODIANS_FILTER_SUCCESS = "GET_CUSTODIANS_FILTER_SUCCESS";
export const GET_CUSTODIANS_FILTER_FAIL = "GET_CUSTODIANS_FILTER_FAIL";
export const GET_RIAS_FILTER_SUCCESS = "GET_RIAS_FILTER_SUCCESS";
export const GET_RIAS_FILTER_FAIL = "GET_RIAS_FILTER_FAIL";
export const GET_ADVISORS_FILTER_SUCCESS = "GET_ADVISORS_FILTER_SUCCESS";
export const GET_ADVISORS_FILTER_FAIL = "GET_ADVISORS_FILTER_FAIL";
export const GET_BENCHMARK_DATA_SUCCESS = "GET_BENCHMARK_DATA_SUCCESS";
export const GET_BENCHMARK_DATA_FAIL = "GET_BENCHMARK_DATA_FAIL";
export const APPLY_FILTER_INCOMING_CLIENT_LIST_TABLE =
  "APPLY_FILTER_INCOMING_CLIENT_LIST_TABLE";
export const GET_LIST_OF_FIRM_CLIENTS_SUCCESS =
  "GET_LIST_OF_FIRM_CLIENTS_SUCCESS";
export const GET_LIST_OF_FIRM_CLIENTS_FAIL = "GET_LIST_OF_FIRM_CLIENTS_FAIL";
export const GET_RECENTLY_FUNDED_ACCOUNT_REPORT_SUCCESS =
  "GET_RECENTLY_FUNDED_ACCOUNT_REPORT_SUCCESS";
export const GET_RECENTLY_FUNDED_ACCOUNT_REPORT_FAIL =
  "GET_RECENTLY_FUNDED_ACCOUNT_REPORT_FAIL";
export const GET_EDIT_FIRM_CLIENT_DETAILS_SUCCESS =
  "GET_EDIT_FIRM_CLIENT_DETAILS_SUCCESS";
export const RESET_EDIT_CLIENT_FARM = "RESET_EDIT_CLIENT_FARM";
export const GET_RECENTLY_REGISTERED_ACCOUNT_REPORT_SUCCESS =
  "GET_RECENTLY_REGISTERED_ACCOUNT_REPORT_SUCCESS";
export const DELETE_ADVISOR_PORTAL_USER_SUCCESS =
  "DELETE_ADVISOR_PORTAL_USER_SUCCESS";
export const DELETE_ADVISOR_PORTAL_USER_FAIL =
  "DELETE_ADVISOR_PORTAL_USER_FAIL";
export const GET_COMPANY_LOGO_SUCCESS = "GET_COMPANY_LOGO_SUCCESS";
export const GET_COMPANY_LOGO_FAIL = "GET_COMPANY_LOGO_FAIL";
export const GET_RIAS_FOR_ADVISOR_SUCCESS = "GET_RIAS_FOR_ADVISOR_SUCCESS";
export const GET_RIAS_FOR_ADVISOR_FAIL = "GET_RIAS_FOR_ADVISOR_FAIL";
export const GET_ROLES_FOR_ADVISOR_SUCCESS = "GET_ROLES_FOR_ADVISOR_SUCCESS";
export const FIRM_ADD_USER_SUCCESSFUL = "FIRM_ADD_USER_SUCCESSFUL";
export const RESET_ADD_ADVISOR_PORTAL_USER = "RESET_ADD_ADVISOR_PORTAL_USER";
export const GET_LIST_OF_FIRM_CLIENTS_BY_FIRM_ID_SUCCESS =
  "GET_LIST_OF_FIRM_CLIENTS_BY_FIRM_ID_SUCCESS";
export const RESET_DELETE_ADVISOR_PORTAL_USER_SUCCESS =
  "RESET_DELETE_ADVISOR_PORTAL_USER_SUCCESS";
export const GET_ASSET_UNDER_MANAGEMENT_SUCCESS =
  "GET_ASSET_UNDER_MANAGEMENT_SUCCESS";
export const GET_TOP_CLIENTS_SUCCESS = "GET_TOP_CLIENTS_SUCCESS";
export const GET_TOP_CLIENTS_FAIL = "GET_TOP_CLIENTS_FAIL";
export const GET_DASHBOARD_RELATIONSHIPS_SUCCESS =
  "GET_DASHBOARD_RELATIONSHIPS_SUCCESS";
export const GET_DASHBOARD_RELATIONSHIPS_FAIL =
  "GET_DASHBOARD_RELATIONSHIPS_FAIL";
export const GET_MASTER_ACCOUNTS_SUCCESS = "GET_MASTER_ACCOUNTS_SUCCESS";
export const GET_MASTER_ACCOUNTS_FAIL = "GET_MASTER_ACCOUNTS_FAIL";
export const ADD_MASTER_ACCOUNTS_SUCCESS = "ADD_MASTER_ACCOUNTS_SUCCESS";
export const ADD_MASTER_ACCOUNTS_FAIL = "ADD_MASTER_ACCOUNTS_FAIL";
export const REMOVE_MASTER_ACCOUNTS_SUCCESS = "REMOVE_MASTER_ACCOUNTS_SUCCESS";
export const REMOVE_MASTER_ACCOUNTS_FAIL = "REMOVE_MASTER_ACCOUNTS_FAIL";
export const RESET_MASTER_ACCOUNTS = "RESET_MASTER_ACCOUNTS";
